import React, { useEffect } from 'react';
import { useUnits } from './UnitStore';
import { Button, Form, Input } from 'antd';
import { useForm } from 'antd/es/form/Form';

function Edit() {
    let {updateUnit, ed} = useUnits()
    let [form] = useForm();
    useEffect(() => {
        form.setFieldsValue(ed)
    }, [ed])
    return (
        <Form form={form} layout="vertical" onFinish={updateUnit} encType="multipart/form-data">
            <Form.Item name={'id'} hidden>
                <Input />
            </Form.Item>
            <Form.Item name={'nameuz'} label="O'zbekcha nomi">
                <Input />
            </Form.Item>
            <Form.Item name={'nameru'} label="Ruscha nomi">
                <Input />
            </Form.Item>
            <Form.Item name={'shortuz'} label="Qisqartirilgan o'zbekcha">
                <Input />
            </Form.Item>
            <Form.Item name={'shortru'} label="Qisqartirilgan ruscha">
                <Input />
            </Form.Item>
            <Form.Item>
                <Button type="primary" htmlType="submit">O'zgartirish</Button>
            </Form.Item>
        </Form>
    );
}

export default Edit;